/**
 * UTM capture — CostControlX marketing SSOT.
 *
 * Ai primi ingressi da una campagna (utm_source/medium/campaign/content/term
 * nell'URL) salva i parametri in sessionStorage e li rende disponibili al
 * signup / lead form come attributi tecnici (mai visibili all'utente).
 *
 * Non tocca signup/login/trial. Nessun dato personale. Nessun cookie.
 */

const KEY = "ccx.utm";
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

function _parseSearch() {
  if (typeof window === "undefined") return {};
  try {
    const q = new URLSearchParams(window.location.search);
    const out = {};
    let has = false;
    for (const k of KEYS) {
      const v = q.get(k);
      if (v) { out[k] = v; has = true; }
    }
    return has ? out : {};
  } catch (_) { return {}; }
}

/**
 * Se l'URL corrente ha almeno un `utm_*`, salva/aggiorna in sessionStorage.
 * Da chiamare al primo render del layout marketing.
 */
export function captureUtmFromUrl() {
  if (typeof window === "undefined") return null;
  const parsed = _parseSearch();
  if (Object.keys(parsed).length === 0) return null;
  try {
    const payload = { ...parsed, captured_at: new Date().toISOString() };
    window.sessionStorage.setItem(KEY, JSON.stringify(payload));
    return payload;
  } catch (_) { return parsed; }
}

/**
 * Ritorna l'oggetto UTM catturato (o `null`). Uso: allegare al payload del
 * form Contact / signup per dare a Meta Ads visibilità sulla sorgente.
 */
export function getCapturedUtm() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) { return null; }
}

export function clearCapturedUtm() {
  if (typeof window === "undefined") return;
  try { window.sessionStorage.removeItem(KEY); } catch (_) {}
}
